<div class="compare-buttons">
  <!-- <core-helpers-forms-button-white class="compare-action" [hidden]="!graphic" [text]="'Compare graphic'" (submit)="goToGraphic()"></core-helpers-forms-button-white> -->
  <core-helpers-forms-button-white class="compare-action" [text]="'Compare graphics'" (submit)="goToGraphic()" [disabled]="!graphic"></core-helpers-forms-button-white>
  <core-helpers-forms-button-white class="compare-action" [text]="'Compare texts'" (submit)="goToContent()" [disabled]="!content"></core-helpers-forms-button-white>
</div>
